import { createSignalRClient } from '@/shared/api'
import { SIGNALR_EVENTS, SIGNALR_HUBS, getSignalRHubUrl } from '@/shared/config'
import { type HubConnectionState } from '@microsoft/signalr'

export class RadioSignalRService {
  private client = createSignalRClient(getSignalRHubUrl(SIGNALR_HUBS.FEEDBACKS))

  async connect(): Promise<void> {
    await this.client.connect()
  }

  async disconnect(): Promise<void> {
    await this.client.disconnect()
  }

  /**
   * Подписка на событие начала радио
   */
  onRadioStarted(callback?: () => void): void {
    this.client.on(SIGNALR_EVENTS.ON_RADIO_STARTED, () => {
      try {
        callback?.()
      } catch (error) {
        console.error('Ошибка валидации данных SignalR (radio):', error)
      }
    })
  }
  offRadioStarted(): void {
    this.client.off(SIGNALR_EVENTS.ON_RADIO_STARTED)
  }
  /**
   * Подписка на событие завершения радио
   */
  onRadioEnded(callback?: () => void): void {
    this.client.on(SIGNALR_EVENTS.ON_RADIO_ENDED, () => {
      try {
        callback?.()
      } catch (error) {
        console.error('Ошибка валидации данных SignalR (radio):', error)
      }
    })
  }

  offRadioEnded(): void {
    this.client.off(SIGNALR_EVENTS.ON_RADIO_ENDED)
  }

  get isConnected(): boolean {
    return this.client.isConnected
  }

  get connectionState(): HubConnectionState {
    return this.client.connectionState
  }
}

export const radioSignalRService = new RadioSignalRService()
